import { useTranslation } from "react-i18next";

import {
  BrandSection,
  EditorialBreak,
  FaqSection,
  FinalCtaSection,
  HeroSection,
  HowItWorksSection,
  IMAGES,
  IncludedSection,
  OrganizerGrid,
  QuoteSection,
} from "@/components/marketing/Sections";
import { PricingSection } from "@/components/marketing/PricingSection";
import { PUBLIC_BASE, useJsonLd, usePageMeta } from "@/lib/seo";
import { BRAND } from "@/config/brand";

export default function Home() {
  const { t } = useTranslation();
  usePageMeta({
    title: t("seo.homeTitle"),
    description: t("seo.homeDesc"),
    image: IMAGES.hero,
    imageAlt: t("seo.homeImageAlt"),
    localized: true,
  });
  /* Grafo de entidades (Fase 13 — WS7): AOS Equestrian (producto) creado por
     Equestrian Partners, Inc. (compañía). Solo datos reales y visibles. */
  useJsonLd({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Corporation",
        "@id": `${PUBLIC_BASE}/#company`,
        name: BRAND.legalName,
        url: PUBLIC_BASE,
      },
      {
        "@type": "Organization",
        "@id": `${PUBLIC_BASE}/#organization`,
        name: BRAND.name,
        url: PUBLIC_BASE,
        logo: `${PUBLIC_BASE}/images/brand/og-default.jpg`,
        parentOrganization: { "@id": `${PUBLIC_BASE}/#company` },
      },
      {
        "@type": "SoftwareApplication",
        "@id": `${PUBLIC_BASE}/#software`,
        name: BRAND.name,
        applicationCategory: "BusinessApplication",
        operatingSystem: "Web",
        url: PUBLIC_BASE,
        description: t("seo.homeDesc"),
        creator: { "@id": `${PUBLIC_BASE}/#company` },
        provider: { "@id": `${PUBLIC_BASE}/#company` },
        offers: {
          "@type": "Offer",
          price: "99",
          priceCurrency: "EUR",
          description: t("pricing.perHorse"),
        },
      },
      {
        "@type": "WebSite",
        "@id": `${PUBLIC_BASE}/#website`,
        name: BRAND.name,
        url: PUBLIC_BASE,
        publisher: { "@id": `${PUBLIC_BASE}/#organization` },
        inLanguage: ["en", "es", "de", "fr", "it"],
      },
    ],
  });

  return (
    <div data-testid="home-page">
      <HeroSection />
      <BrandSection />
      <OrganizerGrid />
      <HowItWorksSection />
      <PricingSection />
      <EditorialBreak />
      <IncludedSection />
      <QuoteSection />
      <FaqSection />
      <FinalCtaSection />
    </div>
  );
}
